import React, { lazy, Suspense } from 'react';

const LazyDealerProfilePage = lazy(() => import('./DealerProfilePage'));

const DealerProfilePage = (props: React.JSX.IntrinsicAttributes & { children?: React.ReactNode; }) => (
  <Suspense fallback={null}>
    <LazyDealerProfilePage {...props} />
  </Suspense>
);

export default DealerProfilePage;
